/*--------------------------------------------------------------
# JS Easepick
--------------------------------------------------------------*/

import {easepick} from 'easepick/bundle';
import {styles} from './plugins/easepick/styles'
import {ShowOffsetDaysPlugin} from './plugins/easepick/ShowOffsetDaysPlugin.js';
import axios from 'axios';
import {
    formatPriceRoundedWithCurrency
} from "../../../../../packages/Divioseo/GTDrive/src/Resources/assets/js/composables/usePrice";

document.addEventListener("DOMContentLoaded", function () {
    const datepickers = document.querySelectorAll('.datepicker');
    const datepickers_inline = document.querySelectorAll('.datepicker_inline');

    datepickers.forEach((element) => {
        const picker = new easepick.create({
            element: element,
            css: styles,
            zIndex: 10,
            lang: "fr-FR",
            format: "DD/MM/YYYY",
            grid: 2,
            calendars: 2,
            showOffsetDays: true,
            locale: {
                previousMonth: `
                    <svg width="7" height="11" viewBox="0 0 7 11" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M6.06 1.13L5 0.07 0 5.07 5 10.07l1.06-1.06L2.12 5.07l3.94-3.94z"></path>
                    </svg>
                `,
                nextMonth: `
                    <svg width="7" height="11" viewBox="0 0 7 11" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M0.94 1.13L2 0.07 7 5.07 2 10.07 0.94 9.01 4.88 5.07 0.94 1.13z"></path>
                    </svg>
                `,
            },
            plugins: [
                ShowOffsetDaysPlugin
            ],
            async setup(picker) {
                let params = {};

                if (element.dataset.type == 'voiture') {
                    params = {
                        voiture_id: element.dataset.id
                    }
                } else {
                    params = {
                        circuit_id: element.dataset.id
                    }
                }
                let dates = {};
                const response = await axios.get('/api/configurator/global', {params});
                if (response.data.success && response.data.datas.stages.length) {
                    Object.values(response.data.datas.stages[0].dates).forEach(date => {
                        dates[date.date] = date
                    })
                }
                picker.on('view', (evt) => {
                    const {view, date, target} = evt.detail;
                    const d = date ? date.format('YYYY-MM-DD') : null;

                    if (view === 'CalendarDay' && dates[d]) {
                        const span = target.querySelector('.day-price') || document.createElement('span');
                        span.className = 'day-price';
                        span.innerHTML = `${formatPriceRoundedWithCurrency(dates[d].price.montant_ttc)}`;
                        target.append(span);
                    } else {
                        target.classList.add('day-disabled');
                    }
                });

                // Capture selected date and expose it via dataset so the configurator directive can read it
                picker.on('select', (evt) => {
                    try {
                        const sel = Array.isArray(evt.detail.date) ? evt.detail.date[0] : evt.detail.date;
                        const d = sel ? sel.format('YYYY-MM-DD') : null;
                        if (!d) return;

                        // Mark the datepicker element with selection info
                        element.dataset.selectedDateIso = d;
                        element.dataset.dateMode = 'choice';

                        if (dates[d] && dates[d].circuit_date_id) {
                            element.dataset.circuitDateId = String(dates[d].circuit_date_id);
                        }

                        // Show reset button
                        const resetButton = element.parentElement.querySelector('.reset-date');
                        if (resetButton) {
                            resetButton.style.display = 'inline-block';
                        }
                    } catch (e) {
                        console.warn('easepick select handler error:', e);
                    }
                });
            }
        });

        function revertPickerPosition() {
            if (picker) {
                picker.options.grid = picker.options.originalGrid || picker.options.grid;
                picker.options.calendars = picker.options.originalCalendars || picker.options.calendars;

                const shadowRoot = picker.ui.shadowRoot;
                const pickerWrapper = shadowRoot.children[0];
                if (pickerWrapper) {
                    pickerWrapper.style.left = '';
                }
                picker.renderAll();
            }
        }


        function adjustPickerPosition() {
            const shadowRoot = picker.ui.shadowRoot;
            const pickerWrapper = shadowRoot.children[0];

            const debouncedRevert = revertPickerPosition();
            window.addEventListener('resize', debouncedRevert, {once: true});

            if (pickerWrapper) {
                let rect = pickerWrapper.getBoundingClientRect();
                let overflowRight = rect.right > window.innerWidth;
                let isSmallScreen = window.innerWidth <= 768; // Augmenter le seuil

                // Seulement réduire à 1 mois si vraiment nécessaire
                if (isSmallScreen) {
                    if (picker.options.grid > 1 || picker.options.calendars > 1) {
                        picker.options.originalGrid = picker.options.grid;
                        picker.options.originalCalendars = picker.options.calendars;

                        picker.options.grid = 1;
                        picker.options.calendars = 1;

                        pickerWrapper.classList.add("single-calendar");
                        picker.renderAll();
                    }
                } else if (overflowRight) {
                    // Juste ajuster la position sans réduire le nombre de mois
                    const adjustment = rect.right - window.innerWidth + 20; // Ajouter un peu de marge
                    const currentLeft = parseFloat(getComputedStyle(pickerWrapper).left) || 0;
                    pickerWrapper.style.left = `${currentLeft - adjustment}px`;
                }
            }
        }

        element.addEventListener("click", (event) => {
            event.stopPropagation();
            adjustPickerPosition();
        });

        picker.ui.shadowRoot.addEventListener("click", (event) => {
            event.stopPropagation();
        });

        // Add reset functionality
        const resetButton = element.parentElement.querySelector('.reset-date');
        if (resetButton) {
            resetButton.addEventListener('click', (event) => {
                event.preventDefault();
                event.stopPropagation();

                // Clear the picker selection completely - try multiple approaches
                try {
                    // Method 1: Try clearSelection if it exists
                    if (typeof picker.clearSelection === 'function') {
                        picker.clearSelection();
                    }

                    // Method 2: Clear internal state
                    if (picker._selectedDates) {
                        picker._selectedDates = [];
                    }

                    // Method 3: Reset picker state completely
                    if (picker.options) {
                        picker.options.date = null;
                    }

                    // Method 4: DON'T use setDate(null) as it sets today's date
                    // if (typeof picker.setDate === 'function') {
                    //     picker.setDate(null);
                    // }

                    // Method 5: Reset the button text to initial state
                    if (element && element.innerHTML) {
                        // Remettre le texte initial "Dates disponibles" avec icône
                        element.innerHTML = '<span>Dates disponibles</span> <i class="bi bi-calendar2-check"></i>';
                    }

                    // Method 6: Clear the input value if it exists
                    if (element && element.value !== undefined) {
                        element.value = '';
                    }

                    // Force re-render to update visual state
                    if (typeof picker.renderAll === 'function') {
                        picker.renderAll();
                    }

                    console.log('🔄 Tentatives de nettoyage picker effectuées');
                } catch (e) {
                    console.warn('Erreur lors du nettoyage du picker:', e);
                }

                // Hide reset button - back to initial state
                resetButton.style.display = 'none';

                // Signal reset to the directive using the existing mechanism
                element.dataset.selectedDateIso = 'reset';
                element.dataset.dateMode = 'reset';
                delete element.dataset.circuitDateId;

                console.log('🔄 Signal reset envoyé à la directive via selectedDateIso = "reset"');

                console.log('Date réinitialisée - datasets supprimés');
            });
        }
    });

    datepickers_inline.forEach((element) => {
        const picker_inline = new easepick.create({
            element: element,
            css: styles,
            zIndex: 10,
            lang: "fr-FR",
            format: "DD/MM/YYYY",
            grid: 1,
            calendars: 1,
            inline: true,
            showOffsetDays: true,
            locale: {
                previousMonth: `
                    <svg width="10" height="20" viewBox="0 0 10 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8.61886 1.2771C8.73218 1.2771 8.87384 1.33376 8.95883 1.41875C9.15714 1.61706 9.15714 1.9287 8.98716 2.12701L1.84788 9.71958C1.70623 9.86123 1.70623 10.1162 1.84788 10.2862L8.98716 17.8788C9.18547 18.0771 9.15714 18.3887 8.95883 18.587C8.76052 18.7853 8.44888 18.757 8.25057 18.5587L1.11129 10.9661C0.629668 10.4278 0.629668 9.57793 1.11129 9.06798L8.25057 1.44708C8.36389 1.33376 8.47721 1.2771 8.61886 1.2771Z" fill="#212B36"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M9.34229 2.44587L2.23644 10.0029L9.3305 17.5474C9.74256 17.9662 9.64294 18.5777 9.29622 18.9244C8.87726 19.3434 8.26155 19.2445 7.91317 18.8961L7.90798 18.8909L0.755588 11.2844C0.116657 10.5703 0.104576 9.4398 0.763687 8.7411C0.763923 8.74086 0.764157 8.74061 0.764393 8.74036L7.90767 1.11519L7.91317 1.10969C8.09172 0.931135 8.32006 0.799952 8.61886 0.799952C8.85728 0.799952 9.12073 0.905867 9.29622 1.08136C9.6773 1.46244 9.67565 2.05695 9.34943 2.43753L9.34229 2.44587ZM1.11129 9.06798C0.629668 9.57793 0.629668 10.4278 1.11129 10.9661L8.25057 18.5587C8.44888 18.757 8.76052 18.7853 8.95883 18.587C9.15714 18.3887 9.18547 18.0771 8.98716 17.8788L1.84788 10.2862C1.70623 10.1162 1.70623 9.86123 1.84788 9.71958L8.98716 2.12701C9.15714 1.9287 9.15714 1.61706 8.95883 1.41875C8.87384 1.33376 8.73218 1.2771 8.61886 1.2771C8.47721 1.2771 8.36389 1.33376 8.25057 1.44708L1.11129 9.06798Z" fill="#212B36"/>
                    </svg>
                `,
                nextMonth: `
                    <svg width="10" height="20" viewBox="0 0 10 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1.38114 18.7229C1.26781 18.7229 1.12616 18.6662 1.04117 18.5812C0.842856 18.3829 0.842857 18.0713 1.01284 17.873L8.15212 10.2804C8.29377 10.1388 8.29377 9.8838 8.15212 9.71381L1.01284 2.12125C0.814526 1.92293 0.842856 1.6113 1.04117 1.41299C1.23948 1.21467 1.55112 1.243 1.74943 1.44132L8.88871 9.03388C9.37033 9.57216 9.37033 10.4221 8.88871 10.932L1.74943 18.5529C1.63611 18.6662 1.52279 18.7229 1.38114 18.7229Z" fill="#212B36"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M0.657712 17.5541L7.76356 9.99712L0.669495 2.45264C0.257438 2.03382 0.357058 1.42232 0.70378 1.0756C1.12274 0.656636 1.73845 0.755545 2.08683 1.10393L2.09202 1.10912L9.24441 8.71563C9.88334 9.42973 9.89542 10.5602 9.23631 11.2589C9.23608 11.2591 9.23584 11.2594 9.23561 11.2596L2.09233 18.8848L2.08683 18.8903C1.90827 19.0689 1.67994 19.2 1.38114 19.2C1.14271 19.2 0.879269 19.0941 0.70378 18.9186C0.322695 18.5376 0.324349 17.9431 0.650567 17.5625L0.657712 17.5541ZM8.88871 10.932C9.37033 10.4221 9.37033 9.57216 8.88871 9.03388L1.74943 1.44132C1.55112 1.243 1.23948 1.21467 1.04117 1.41299C0.842856 1.6113 0.814526 1.92293 1.01284 2.12125L8.15212 9.71381C8.29377 9.8838 8.29377 10.1388 8.15212 10.2804L1.01284 17.873C0.842857 18.0713 0.842856 18.3829 1.04117 18.5812C1.12616 18.6662 1.26781 18.7229 1.38114 18.7229C1.52279 18.7229 1.63611 18.6662 1.74943 18.5529L8.88871 10.932Z" fill="#212B36"/>
                    </svg>
                `,
            },
            plugins: [
                ShowOffsetDaysPlugin
            ],
        });

        if (element.closest('.modal-config-reserv')) {
            const shadowRoot = picker_inline.ui.shadowRoot;
            const pickerWrapper = shadowRoot.children[0];
            pickerWrapper.classList.add('datepicker-in-modal');
        }
    });
});
